<template>
    <div>
        <div class="hero-app-1 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-2 custom-animation2"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-3 custom-animation4"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-4 custom-animation2"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-5 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-6 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-7 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-8 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-9 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-10 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-11 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-12 custom-animation2"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-13 custom-animation4"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-14 custom-animation2"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-15 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-16 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-17 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-18 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-19 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-20 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-21 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-22 custom-animation2"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-23 custom-animation4"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-24 custom-animation2"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-25 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-26 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-27 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-28 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-29 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
        <div class="hero-app-30 custom-animation"><img src="/img/animation/icon_7.png" alt="" class="animated-img"></div>
    </div>
</template>

<script>
    export default {
        name: 'animated-circle',
    }
</script>

<style lang="css" scoped>
    .hero-app-1 {
        position: absolute;
        left: 10%;
        top: 20%;
    }
    .custom-animation {
        backface-visibility: hidden;
        animation: jumping 9s ease-in-out 2s infinite alternate;
        animation-delay: 1s;
        transition: all .9s ease 5s;
        user-select: none;
    }
    .hero-app-2 {
        position: absolute;
        left: 5%;
        bottom: 35%;
    }
    .custom-animation2 {
        backface-visibility: hidden;
        animation: jumping2 9s ease-in-out 2s infinite alternate;
        animation-delay: 1s;
        transition: all 1s ease 3s;
        user-select: none;
    }
    .hero-app-5 {
        position: absolute;
        bottom: 40%;
        left: 50%;
    }
    .custom-animation4 {
        backface-visibility: hidden;
        animation: jumping4 9s ease-in-out 2s infinite alternate;
        animation-delay: 1s;
        transition: all 8s ease 4s;
        user-select: none;
    }
    .hero-app-7 {
        position: absolute;
        top: 13%;
        left: 51%;
    }
    .hero-app-8 {
        position: absolute;
        left: 15%;
        top: 60%;
    }
    .hero-app-3 {
        position: absolute;
        left: 21%;
        top: 40%;
    }
    .hero-app-4 {
        position: absolute;
        left: 31%;
        top: 47%;
    }
    .hero-app-6 {
        position: absolute;
        left: 11%;
        top: 70%;
    }
    .hero-app-9 {
        position: absolute;
        left: 5%;
        top: 25%;
    }
    .hero-app-10 {
        position: absolute;
        left: 45%;
        top: 70%;
    }
    .hero-app-11 {
        position: absolute;
        left: 75%;
        top: 90%;
    }
    .hero-app-12 {
        position: absolute;
        left: 85%;
        top: 60%;
    }
    .hero-app-13 {
        position: absolute;
        left: 25%;
        top: 40%;
    }
    .hero-app-14 {
        position: absolute;
        left: 75%;
        top: 30%;
    }
    .hero-app-15 {
        position: absolute;
        left: 95%;
        top: 5%;
    }
    .hero-app-16 {
        position: absolute;
        left: 15%;
        top: 23%;
    }
    .hero-app-17 {
        position: absolute;
        left: 24%;
        top: 37%;
    }
    .hero-app-18 {
        position: absolute;
        left: 34%;
        top: 87%;
    }
    .hero-app-19 {
        position: absolute;
        left: 87%;
        top: 37%;
    }
    .hero-app-20 {
        position: absolute;
        left: 57%;
        top: 57%;
    }
    .hero-app-21 {
        position: absolute;
        left: 94%;
        top: 87%;
    }
    .hero-app-22 {
        position: absolute;
        left: 64%;
        top: 77%;
    }
    .hero-app-23 {
        position: absolute;
        left: 34%;
        top: 87%;
    }
    .hero-app-24 {
        position: absolute;
        left: 74%;
        top: 77%;
    }
    .hero-app-25 {
        position: absolute;
        left: 32%;
        top: 67%;
    }
    .hero-app-26 {
        position: absolute;
        left: 28%;
        top: 38%;
    }
    .hero-app-27 {
        position: absolute;
        left: 95%;
        top: 75%;
    }
    .hero-app-28 {
        position: absolute;
        left: 27%;
        top: 32%;
    }
    .hero-app-29 {
        position: absolute;
        left: 64%;
        top: 58%;
    }
    .hero-app-30 {
        position: absolute;
        left: 31%;
        top: 48%;
    }
    @keyframes jumping {
        0% {
            transform: translateY(0px) translateX(0) rotate(0) scale(1);
            opacity: .8;
        }
        25% {
            transform: translateY(-10px) translateX(-10px) rotate(20deg) scale(0.8);
            opacity: .9;
        }
        50% {
            transform: translateY(-15px) translateX(-15px) rotate(10deg) scale(0.9);
            opacity: .8;
        }
        75% {
            transform: translateY(-20px) translateX(-20px) rotate(20deg) scale(0.75);
            opacity: .6;
        }
        85% {
            transform: translateY(-25px) translateX(-25px) rotate(20deg) scale(0.9);
            opacity: .7;
        }
        100% {
            transform: translateY(-15px) translateX(-15px) rotate(0) scale(0.95);
            opacity: .85;
        }

    }
    @keyframes jumping2 {
        0% {
            transform: translateY(0px) translateX(0) rotate(0) scale(1);
            opacity: .5;
        }
        25% {
            transform: translateY(-30px) translateX(10px) rotate(20deg) scale(0.8);
            opacity: .8;
        }
        50% {
            transform: translateY(15px) translateX(-15px) rotate(10deg) scale(0.7);
            opacity: .8;
        }
        75% {
            transform: translateY(30px) translateX(20px) rotate(20deg) scale(0.75);
            opacity: .7;
        }
        100% {
            transform: translateY(-15px) translateX(15px) rotate(0) scale(0.75);
            opacity: .9;
        }
    }
    @keyframes jumping4 {
        0% {
            transform: translateY(-30px) translateX(20px) rotate(0) scale(1.2);
            opacity: .7;
        }
        25% {
            transform: translateY(-20px) translateX(10px) rotate(50deg) scale(0.6);
            opacity: .8;
        }
        50% {
            transform: translateY(15px) translateX(-15px) rotate(20deg) scale(0.5);
            opacity: .9;
        }
        75% {
            transform: translateY(30px) translateX(20px) rotate(50deg) scale(0.75);
            opacity: .7;
        }
        100% {
            transform: translateY(-15px) translateX(15px) rotate(0) scale(0.5);
            opacity: .9;
        }
    }
    .animated-img {
        max-width: 100%;
        vertical-align: middle;
        border-style: none;
    }
</style>